import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

// Replace this with your own config details
var config = {
  apiKey: "AIzaSyBEN080c_QGP9xnG3eR9b_gbNXEWg0eai4",
  authDomain: "twitter-clone-dfc4a.firebaseapp.com",
  databaseURL: "https://twitter-clone-dfc4a.firebaseio.com",
  projectId: "twitter-clone-dfc4a",
  storageBucket: "twitter-clone-dfc4a.appspot.com",
  messagingSenderId: "950058325544"
};
firebase.initializeApp(config);
firebase.firestore().settings({ timestampsInSnapshots: true });

export default firebase 


// WEBPACK FOOTER //
// ./src/config/fbConfig.js